import React, { useState, useEffect, useContext } from "react";
import {
    Grid,
    TextField,
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { ActionContext } from 'src/contexts/ActionContext';
import { BusinessManagerContext } from "src/contexts/BusinessManagerContext";

function ProfessionalProjection(props) {
    const { t } = useTranslation();
    const { eepBMData, setEepBMDataContext } = useContext(BusinessManagerContext);
    const { actionToggle } = useContext(ActionContext);
    const isVisu = !actionToggle;
    const [data, setData] = useState({
        shortTermGoal: '',
        shortTermMotivation: '',
        shortTermWay: '',
        longTermGoal: '',
        longTermMotivation: '',
        longTermWay: '',
    });
    useEffect(() => {
        setData({
            shortTermGoal: props.data.shortTermGoal,
            shortTermMotivation: props.data.shortTermMotivation,
            shortTermWay: props.data.shortTermWay,
            longTermGoal: props.data.longTermGoal,
            longTermMotivation: props.data.longTermMotivation,
            longTermWay: props.data.longTermWay,
        })
    }, [props.data]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: value
        });
    }
    const setDataContextValue = () => {
        eepBMData.shortTermGoal = data.shortTermGoal;
        eepBMData.shortTermMotivation = data.shortTermMotivation;
        eepBMData.shortTermWay = data.shortTermWay;
        eepBMData.longTermGoal = data.longTermGoal;
        eepBMData.longTermMotivation = data.longTermMotivation;
        eepBMData.longTermWay = data.longTermWay;
    }
    return (
        <>

            <Grid item xs={12}>
                <h3 style={{ fontStyle: 'italic', fontWeight: 'normal', marginLeft: 2, marginRight: 2 }}>
                    <Trans>eepBm.professionalProjection.label</Trans>
                </h3>
            </Grid>
            <div style={{ backgroundColor: '#ffffff', marginTop: -10 }} >
                <Grid container direction="row" alignItems="stretch" style={{
                    backgroundColor: '#2c9a42',
                    color: '#ffffff',
                    height: 50,
                    textAlign: 'center',
                    fontSize: 12,
                    textTransform: 'uppercase',
                    marginTop: 15,
                    borderRadius: 3
                }}>
                    <Grid item xs={6} >
                        <h3><Trans>eepBm.professionalProjection.title1</Trans></h3>
                    </Grid>
                    <Grid item xs={6} >
                        <h3><Trans>eepBm.professionalProjection.title2</Trans></h3>
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={6} >
                        <TextField
                            label={t('eepBm.professionalProjection.field1')}
                            variant="outlined"
                            fullWidth
                            name="shortTermGoal"
                            value={data.shortTermGoal}
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            multiline
                            inputProps={{
                                maxLength: 4094
                            }}
                            disabled={isVisu}
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <TextField
                            label={t('eepBm.professionalProjection.field1')}
                            variant="outlined"
                            fullWidth
                            name="longTermGoal"
                            value={data.longTermGoal}
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            multiline
                            inputProps={{
                                maxLength: 4094
                            }}
                            disabled={isVisu}
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <TextField
                            label={t('eepBm.professionalProjection.field2')}
                            variant="outlined"
                            fullWidth
                            name="shortTermMotivation"
                            value={data.shortTermMotivation}
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            multiline
                            inputProps={{
                                maxLength: 4094
                            }}
                            disabled={isVisu}
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <TextField
                            label={t('eepBm.professionalProjection.field2')}
                            variant="outlined"
                            fullWidth
                            name="longTermMotivation"
                            value={data.longTermMotivation}
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            multiline
                            inputProps={{
                                maxLength: 4094
                            }}
                            disabled={isVisu}
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <TextField
                            label={t('eepBm.professionalProjection.field3')}
                            variant="outlined"
                            fullWidth
                            name="shortTermWay"
                            value={data.shortTermWay}
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            multiline
                            inputProps={{
                                maxLength: 4094
                            }}
                            disabled={isVisu}
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <TextField
                            label={t('eepBm.professionalProjection.field3')}
                            variant="outlined"
                            fullWidth
                            name="longTermWay"
                            value={data.longTermWay}
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            multiline
                            inputProps={{
                                maxLength: 4094
                            }}
                            disabled={isVisu}
                        />
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ProfessionalProjection;